export default {
    api: 'background: #222; color: #bada55; font-size: 20px; padding: 15px 25px;',
    apiData: 'background: #333; color: #bada55; font-size: 14px; padding: 10px 25px;',
    apiResponse: 'background: #00b894; color: #ffffff; font-size: 14px; padding: 10px 25px;',
    cacheResponse: 'background: #fdcb6e; color: #ffffff; font-size: 14px; padding: 10px 25px;',
    apiResponseError: 'background: #d63031; color: #ffffff; font-size: 14px; padding: 10px 25px;',

    appCommand: 'background: #17c0eb; color: #7efff5; font-size: 20px; padding: 15px 25px;',
    error: 'background: #d63031; color: #fff; font-size: 16px; padding: 10px 15px;',
}